export default __webpack_public_path__ + "static/media/T-box-slider1.5248f0da.jpg";